import { render, staticRenderFns } from "./ExternalCalls.vue?vue&type=template&id=a8c423c8"
import script from "./ExternalCalls.vue?vue&type=script&lang=js"
export * from "./ExternalCalls.vue?vue&type=script&lang=js"
import style0 from "./ExternalCalls.vue?vue&type=style&index=0&id=a8c423c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports